import React, { useState, useEffect } from "react";
import Header from "./Header.js";
import Loader from "./Loader.js";
import "./Css/WeekReport.css";
import {
  handleError,
  handleSuccess,
  goBack,
  formatDateStringdot,
  mondayDayYearFormat,
} from "../CommonJquery/CommonJquery.js";
import { Button } from "@mui/material";

import {
  add_payment_mutiple_drop_final,
  get_booking_details,
  server_post_data,
} from "../ServiceConnection/serviceconnection.js";
import { useLocation } from "react-router-dom";
import { User, Mail, Phone, CreditCard, Car, ArrowLeft } from "lucide-react";
import ViewDiscountModal from "./Payment.js/ViewDiscountModal.js";
import Breadcrumb from "../CommonJquery/Breadcrumb.js";

export default function WeeklyReport() {
  const location = useLocation();
  const data = location.state.option;
  const carData = data.car_data[0];
  const booking_id = data.primary_id;
  const car_id = data.car_id;
  const globalStartDate = data.from_date;
  const deposit = data.total_deposit;
  const total_maintance = data.total_maintance;
  const per_total_latefees = data.total_latefees;
  const per_total_ipass = data.total_ipass;
  const per_total_damagefees = data.total_damagefees;
  const per_total_addon = data.total_addon;

  const [showLoaderAdmin, setshowLoaderAdmin] = useState(false);
  const parseDate = (dateStr) => {
    const [year, month, day] = dateStr.split("-");
    return new Date(`${month}-${day}-${year}`);
  };
  const parsedStartDate = parseDate(globalStartDate);
  const getCurrentDate = () => {
    const today = new Date();
    return today;
  };

  // Check if a date is today
  const isToday = (date) => {
    const today = getCurrentDate();
    return (
      date.getDate() === today.getDate() &&
      date.getMonth() === today.getMonth() &&
      date.getFullYear() === today.getFullYear()
    );
  };

  // Check if a date is in the future
  const isDateInFuture = (date) => {
    const today = getCurrentDate();
    return date > today;
  };

  // Calculate weeks needed
  const calculateWeeksNeeded = () => {
    const start = new Date(parsedStartDate); // e.g., May 30, 2025
    //const today = getCurrentDate();          // e.g., May 21, 2025

    const today = new Date(getCurrentDate());
    today.setDate(today.getDate() + 1);

    // Get the raw difference in milliseconds
    const diffTime = today - start;

    // Convert milliseconds to days (could be negative)
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

    //console.log("start", start);
    //console.log("today", today);
    //console.log("diffDays", diffDays);

    if (diffDays < 0) {
      return 0; // or return negative weeks if you want
    }

    // Return number of weeks (ceil to include partial weeks)
    return Math.ceil(diffDays / 7);
  };

  const convertNumberToWord = (num) => {
    const words = [
      "Zero",
      "One",
      "Two",
      "Three",
      "Four",
      "Five",
      "Six",
      "Seven",
      "Eight",
      "Nine",
      "Ten",
      "Eleven",
      "Twelve",
      "Thirteen",
      "Fourteen",
      "Fifteen",
      "Sixteen",
      "Seventeen",
      "Eighteen",
      "Nineteen",
      "Twenty",
    ];
    if (num >= 0 && num <= 20) {
      return words[num];
    } else {
      return num.toString(); // Default to string if number is out of range
    }
  };

  const [payments, setPayments] = useState([]);
  const [weekTotals, setWeekTotals] = useState([]);
  const [generatedTill, setGeneratedTill] = useState(null);

  //Rents
  const [rentTotal, setRentTotal] = useState(0);
  const [rentPaid, setRentPaid] = useState(0);
  const [rentDue, setRentDue] = useState(0);
  const [rentDiscount, setRentDiscount] = useState(0);
  const [rentDiscountBalance, setRentDiscountBalance] = useState(0);
  const [rentDiscountUsed, setRentDiscountUsed] = useState(0);
  const [totalAdvance, setTotalAdvance] = useState(0);
  const [totalAdvanceBalance, setAdvanceBalance] = useState(0);
  const [totalRefundAmount, setRefundAmount] = useState(0);
  const [totalRentAdvance, setTotalRentAdvance] = useState(0);
  const [totalRentBalanceAdvance, setTotalRentBalanceAdvance] = useState(0);
  const [totalRentUsedAdvance, setTotalRentUsedAdvance] = useState(0);

  // Tolls
  const [tollsTotal, setTollsTotal] = useState(0);
  const [tollsPaid, setTollsPaid] = useState(0);
  const [tollsDue, setTollsDue] = useState(0);
  const [tollsDiscountUsed, setTollsDiscountUsed] = useState(0);
  const [tollsDiscountBalance, setTollsDiscountBalance] = useState(0);
  const [totalTollAdvance, setTotalTollAdvancet] = useState(0);
  const [totalTollBalanceAdvance, settotalTollBalanceAdvance] = useState(0);
  const [totalTollUsedAdvance, setTotalTollUsedAdvance] = useState(0);

  // Damage
  const [damageTotal, setDamageTotal] = useState(0);
  const [damagePaid, setDamagePaid] = useState(0);
  const [damageDue, setDamageDue] = useState(0);
  const [damageDiscountUsed, setDamageDiscountUsed] = useState(0);
  const [damageDiscountBalance, setDamageDiscountBalance] = useState(0);

  // Tickets
  const [ticketsTotal, setTicketsTotal] = useState(0);
  const [ticketsPaid, setTicketsPaid] = useState(0);
  const [ticketsDue, setTicketsDue] = useState(0);
  const [ticketsDiscountUsed, setTicketsDiscountUsed] = useState(0);
  const [ticketsDiscountBalance, setTicketsDiscountBalance] = useState(0);

  // Other Charges
  const [otherChargesTotal, setOtherChargesTotal] = useState(0);
  const [otherChargesPaid, setOtherChargesPaid] = useState(0);
  const [otherChargesDue, setOtherChargesDue] = useState(0);
  const [otherChargesDiscount, setOtherChargesDiscount] = useState(0);
  const [otherChargesDiscountUsed, setOtherChargesDiscountUsed] = useState(0);
  const [otherChargesDiscountBalance, setOtherChargesDiscountBalance] =
    useState(0);

  // Late Fees
  const [lateFeesTotal, setLateFeesTotal] = useState(0);
  const [lateFeesPaid, setLateFeesPaid] = useState(0);
  const [lateFeesDue, setLateFeesDue] = useState(0);
  const [lateFeesDiscount, setLateFeesDiscount] = useState(0);
  const [lateFeesDiscountBalance, setLateFeesDiscountBalance] = useState(0);

  // Deposit
  const [depositTotal, setDepositTotal] = useState(0);
  const [depositPaid, setDepositPaid] = useState(0);
  const [depositDue, setDepositDue] = useState(0);

  const [usedDiscount, setusedDiscount] = useState(0);
  const [balanceAdvance, setBalanceAdvance] = useState(0);
  const [totalDiscount, setTotalDiscount] = useState(0);
  const [balanceDiscount, setBalanceDiscount] = useState(0);
  const [usedAdjustment, setusedAdjustment] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [totalPaid, setTotalPaid] = useState(0);
  const [totalDue, setTotalDue] = useState(0);

  const [depositBalance, setDepositBalance] = useState(0);

  const [selectdaydate, setSelectDayDate] = useState("");
  const [selectdayRent, setSelectDayRent] = useState(0);
  const [selectdaySurcharge, setSelectDaySurcharge] = useState(0);
  const [selectdaytoll, setSelectDayToll] = useState(0);
  const [selectdaydamage, setSelectDayDamage] = useState(0);
  const [selectdayticket, setSelectTicket] = useState(0);
  const [selectdayotherCharge, setSelectDayotherCharge] = useState(0);
  const [selectdaydiscount, setSelectDayDiscount] = useState(0);
  const [selectdaytotal, setSelectDayTotal] = useState(0);

  const [lateFees, setLateFees] = useState(per_total_latefees);
  const [Ipass, setIpass] = useState(per_total_ipass);
  const [discount, setdiscount] = useState();
  const [Maintanceamount, setMaintanceamount] = useState(total_maintance);
  const [TotalRent, setTotalRent] = useState(0);
  const weeks = calculateWeeksNeeded();
  const [Booking, setBooking] = useState([]);
  const [BookingPayments, setBookingPayments] = useState([]);

  // ✅ Recalculate totals when payments change
  useEffect(() => {
    const newWeekTotals = payments.map((weekData) =>
      weekData.reduce((total, day) => {
        const amount = Number.parseFloat(day.amount) || 0;
        return total + amount;
      }, 0)
    );
    setWeekTotals(newWeekTotals);

    const newDayTotals = [0, 0, 0, 0, 0, 0, 0];
    for (let dayIndex = 0; dayIndex < 7; dayIndex++) {
      newDayTotals[dayIndex] = payments.reduce((total, week) => {
        const amount = Number.parseFloat(week[dayIndex]?.amount) || 0;
        return total + amount;
      }, 0);
    }
    const newRentTotal = newDayTotals.reduce(
      (total, dayTotal) => total + dayTotal,
      0
    );
    //setRentTotal(newRentTotal); //comment by mk
  }, [payments]);

  const handlePaymentChange = (weekIndex, dayIndex, value) => {
    const newPayments = [...payments];
    newPayments[weekIndex][dayIndex].amount = value;
    setPayments(newPayments);
  };
  const pickservicecharges = (
    weekIndex,
    dayIndex,
    entry_date,
    amount,
    toll_charge,
    damage_charge,
    ticket_charge,
    other_charge,
    per_day_rent,
    per_day_surcharges,
    discount_charge
  ) => {
    setSelectDayDate(entry_date);
    setSelectDayRent(per_day_rent);
    setSelectDaySurcharge(per_day_surcharges);
    setSelectDayToll(toll_charge);
    setSelectDayDamage(damage_charge);
    setSelectTicket(ticket_charge);
    setSelectDayotherCharge(other_charge);
    setSelectDayDiscount(discount_charge);
    const total =
      Number(per_day_rent) +
      Number(per_day_surcharges) +
      Number(toll_charge) +
      Number(damage_charge) +
      Number(ticket_charge) +
      Number(other_charge) -
      Number(discount_charge); // assuming discount reduces total
    setSelectDayTotal(total);
    // const newPayments = [...payments];
    // newPayments[weekIndex][dayIndex].amount = value;
    // setPayments(newPayments);
  };

  const formatDate = (date) => {
    if (!date) return "";
    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear().toString().slice(-2);
    return `${day}-${month}-${year}`;
  };

  const formatCurrency = (amount) => {
    return `$ ${Number.parseFloat(amount).toFixed(2)}`;
  };

  const getFormattedCurrentDate = () => {
    const now = new Date();
    return `${now.getMonth() + 1}/${now.getDate()}/${now.getFullYear()}`;
  };

  const getWeekAfterStartDate = () => {
    const startDate = new Date(parsedStartDate);
    startDate.setDate(startDate.getDate() + 7);
    return formatDate(startDate);
  };

  // Fixed day headers
  const dayHeaders = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

  const [manualRentTotal, setManualRentTotal] = useState(0);
  const [manualTollsBalance, setManualTollsBalance] = useState(0);
  const [manualFinalTotal, setManualFinalTotal] = useState(0);

  // View Discount Modal

  const [showDiscountModal, setShowDiscountModal] = useState(false);

  // Example discount data - in a real app, this would come from your state or API
  const discounts = [
    { date: "2023-04-15", amount: 120.5, note: "Customer loyalty discount" },
    { date: "2023-04-18", amount: 75.0, note: "Bulk purchase discount" },
    { date: "2023-04-20", amount: 50.0, note: "First-time customer" },
    { date: "2023-04-22", amount: 200.0, note: "Seasonal promotion" },
    { date: "2023-04-25", amount: 35.75, note: "Damaged product compensation" },
  ];

  useEffect(() => {
    setManualRentTotal(rentTotal);
  }, [rentTotal]);

  useEffect(() => {
    const calcTotal =
      rentTotal + manualTollsBalance + damageTotal + lateFees + Ipass - 0;
    setManualFinalTotal(calcTotal);
  }, [rentTotal, manualTollsBalance, damageTotal, lateFees, 0, Ipass]);
  const handleRentChange = (e) => {
    const value = parseFloat(e.target.value) || 0;
    setManualRentTotal(value);
  };

  const handleTollsChange = (e) => {
    const value = parseFloat(e.target.value) || 0;
    setManualTollsBalance(value);
  };

  const handleDamageChange = (e) => {
    const value = parseFloat(e.target.value) || 0;
    setDamageTotal(value);
  };

  const handleLateFeesChange = (e) => {
    const value = parseFloat(e.target.value) || 0;
    setLateFees(value);
  };

  const handleIpassChange = (e) => {
    const value = parseFloat(e.target.value) || 0;
    setIpass(value);
  };

  const handleDepositChange = (e) => {
    const value = parseFloat(e.target.value) || 0;
    //setDepositBalance(value);
  };

  const handleFinalTotalChange = (e) => {
    const value = parseFloat(e.target.value) || 0;
    setManualFinalTotal(value);
  };

  const handleSaveChangesdynamic = async () => {
    let vaild_data = true;

    if (vaild_data) {
      setshowLoaderAdmin(true);
      let formData = new FormData();
      formData.append("booking_id", booking_id);
      formData.append("car_id", car_id);
      formData.append("weeks_data", JSON.stringify(payments));
      formData.append("manualTollsBalance", manualTollsBalance);
      formData.append("damageTotal", damageTotal);
      formData.append("lateFees", lateFees);
      //formData.append("depositBalance", depositBalance);
      formData.append("total_maintance", Maintanceamount);
      formData.append("total_ipass", Ipass);
      formData.append("user_id", data.user_id);

      await server_post_data(add_payment_mutiple_drop_final, formData)
        .then((Response) => {
          setshowLoaderAdmin(false);
          if (Response.data.error) {
            handleError(Response.data.message);
          } else {
            handleSuccess(Response.data.message);
          }
        })
        .catch((error) => {
          setshowLoaderAdmin(false);
        });
    }
  };

  useEffect(() => {
    master_data_get();
  }, []);

  const master_data_get = async () => {
    setshowLoaderAdmin(true);
    const fd = new FormData();
    fd.append("booking_id", booking_id);
    fd.append("car_id", car_id);
    await server_post_data(get_booking_details, fd)
      .then((Response) => {
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          const newPayments = [];
          // Calculate the Monday before the start date to establish where days fall in the grid
          const firstMonday = new Date(parsedStartDate);
          const startDay = parsedStartDate.getDay(); // 6 for Saturday
          firstMonday.setDate(
            parsedStartDate.getDate() - ((startDay - 1 + 7) % 7)
          );

          let currentDate = new Date(firstMonday);
          const paymentData = Response.data?.message.booking_data_payment || [];
          const ServiceData = Response.data?.message.service_data_payment || [];
          const DiscountData =
            Response.data?.message.discount_data_payment || [];
          setBooking(Response.data.message.booking_data[0]);
          setBookingPayments(paymentData);
          const data = Response.data.message.booking_data[0];
          console.log("data data:", data);
          setGeneratedTill(data.last_link_date);
          // Rent
          setRentTotal(data.total_rent || 0);
          setRentPaid(data.paid_rent || 0);
          setRentDue(data.due_rent || 0);
          setRentDiscount(data.rent_discount || 0);
          setRentDiscountBalance(data.rent_balance_discount || 0);
          setRentDiscountUsed(data.rent_used_discount || 0);
          setTotalRentAdvance(data.rent_advance || 0);
          setTotalRentBalanceAdvance(data.rent_balance_advance || 0);
          setTotalRentUsedAdvance(data.rent_used_advance || 0);

          // Tolls
          setTollsTotal(data.total_tolls || 0);
          setTollsPaid(data.paid_tolls || 0);
          setTollsDue(data.due_tolls || 0);
          // setTollsDiscount(data.toll_discount || 0);
          setTollsDiscountBalance(data.toll_balance_discount || 0);
          setTollsDiscountUsed(data.ticket_used_discount || 0);
          setTotalTollAdvancet(data.toll_advance || 0);
          settotalTollBalanceAdvance(data.toll_balance_advance || 0);
          setTotalTollUsedAdvance(data.toll_used_advance || 0);

          // Damage
          setDamageTotal(data.total_damagefees || 0);
          setDamagePaid(data.paid_damage || 0);
          setDamageDue(data.due_damage || 0);
          setDamageDiscountUsed(data.damage_used_discount || 0);
          setDamageDiscountBalance(data.damage_balance_discount || 0);

          // Tickets
          setTicketsTotal(data.total_tickets || 0);
          setTicketsPaid(data.paid_ticket || 0);
          setTicketsDue(data.due_ticket || 0);
          // setTicketsDiscount(data.ticket_discount || 0);
          setTicketsDiscountBalance(data.ticket_balance_discount || 0);
          setTicketsDiscountUsed(data.ticket_used_discount || 0);

          // Other Charges
          setOtherChargesTotal(data.total_other_charges || 0);
          setOtherChargesPaid(data.paid_other_charges || 0);
          setOtherChargesDue(data.due_other_charges || 0);
          setOtherChargesDiscount(data.otherCharges_discount || 0);
          setOtherChargesDiscountUsed(data.otherCharges_used_discount || 0);
          setOtherChargesDiscountBalance(
            data.otherCharges_balance_discount || 0
          );

          // Late Fees
          setLateFeesTotal(data.total_latefees || 0);
          setLateFeesPaid(data.paid_latefees || 0);
          setLateFeesDue(data.due_latefees || 0);
          setLateFeesDiscount(data.latefees_discount || 0);
          setLateFeesDiscountBalance(data.latefees_balance_discount || 0);

          // Deposit
          setDepositTotal(data.total_deposit || 0);
          setDepositPaid(data.paid_deposit || 0);
          setDepositDue(data.due_deposit || 0);

          // Advance
          setTotalAdvance(data.total_advance || 0);
          setAdvanceBalance(data.balance_advance || 0);
          setRefundAmount(data.refund_amount || 0);

          // Discounts (overall, if needed)
          setTotalDiscount(data.total_discount || 0);
          setBalanceDiscount(data.balance_discount || 0);
          setusedDiscount(data.used_discount || 0);
          setusedAdjustment(data.used_adjustment || 0);
          setBalanceAdvance(data.balance_advance || 0);

          // Total Summary
          setTotalAmount(data.total_amount || 0);
          setTotalPaid(data.total_paid || 0);
          setTotalDue(data.total_due || 0);

          setTotalAdvance(
            Response.data.message.booking_data[0].total_advance || 0
          );
          setAdvanceBalance(
            Response.data.message.booking_data[0].balance_advance || 0
          );

          setDamageTotal(
            Response.data.message.booking_data[0].total_damagefees || 0
          );
          setLateFees(
            Response.data.message.booking_data[0].total_latefees || 0
          );
          setIpass(Response.data.message.booking_data[0].total_ipass || 0);
          setDepositBalance(
            Response.data.message.booking_data[0].total_deposit || 0
          );
          setMaintanceamount(
            Response.data.message.booking_data[0].total_maintance || 0
          );
          let per_date_charge_dd =
            Response.data.message.booking_data[0].per_date_charge || 0;
          let total_rent = 0;
          let per_day_rent =
            Response.data.message.booking_data[0].per_day_rent || 0;
          let per_day_surcharges =
            Response.data.message.booking_data[0].per_day_surcharges || 0;
          //console.log('weekcal',weeks);
          for (let week = 0; week < weeks; week++) {
            const weekData = [];

            for (let day = 0; day < 7; day++) {
              const date = new Date(currentDate.getTime());
              const isFutureDate = isDateInFuture(date);
              const isBeforeStartDate = date < parsedStartDate;
              const shouldReduceOpacity = isFutureDate || isBeforeStartDate;
              let amount = 0;
              let refund = 0;
              let toll_charge = 0;
              let damage_charge = 0;
              let ticket_charge = 0;
              let other_charge = 0;
              let discount_charge = 0;
              let entry_date = date.toISOString().split("T")[0];
              entry_date = date.toLocaleDateString("en-CA");
              paymentData.forEach((data) => {
                if (data.payment_date === entry_date) {
                  if (data.refund_status == 0) {
                    amount += Number(data.total_amount);
                  } else {
                    refund += Number(data.total_amount);
                  }
                }
              });
              ServiceData.forEach((data) => {
                if (data.service_date === entry_date) {
                  toll_charge += Number(data.toll_charge);
                  damage_charge += Number(data.damage_charge);
                  ticket_charge += Number(data.ticket_charge);
                  other_charge += Number(data.other_charge);
                }
              });
              DiscountData.forEach((data) => {
                if (data.discount_date === entry_date) {
                  discount_charge += Number(data.discount_charge);
                }
              });
              let check = "1";
              if (!shouldReduceOpacity) {
                check = "0";
                total_rent += parseFloat(per_date_charge_dd);
              }
              weekData.push({
                date,
                entry_date: entry_date,
                check_value: check,
                amount: amount,
                per_day_rent: per_day_rent,
                per_day_surcharges: per_day_surcharges,
                toll_charge: toll_charge,
                damage_charge: damage_charge,
                ticket_charge: ticket_charge,
                other_charge: other_charge,
                discount_charge: discount_charge,
                total_rent_actual: per_date_charge_dd,
                refund: refund,
              });
              currentDate.setDate(currentDate.getDate() + 1);
            }

            newPayments.push(weekData);
          }
          setTotalRent(total_rent);
          setPayments(newPayments);
        }
        setshowLoaderAdmin(false);
      })
      .catch((error) => {
        console.log(error);
        handleError("network");
        setshowLoaderAdmin(false);
      });
  };

  const driverInfo = {
    name: "John Doe",
    email: "john.doe@example.com",
    phone: "+1 (555) 123-4567",
    license: "DL-123456789",
    carInfo: "Toyota Camry 2022 (White) - Plate: ABC1234",
  };

  return (
    <div>
      {showLoaderAdmin && <Loader />}

      <Header />
      <div className="pageCntn_head">
        <div className="pageNameDiv">
          {/* <p>Customer History</p>

          <img src={GreyArrow} alt="Rapid Car Leasing" /> */}
          <Breadcrumb
            items={[
              { label: "All Drivers Report", path: "/payment-reports" },
              { label: "Weekly Report", path: "/WeeklyReport" },
            ]}
          />
        </div>
        <Button
          onClick={goBack}
          startIcon={<ArrowLeft size={17} style={{ marginBottom: "2px" }} />}
          className="Back_bttn_page"
        >
          Back
        </Button>
      </div>
      <div className="driver-details-card">
        <div className="row">
          <div className="col-md-12">
            <h4 className="driver-details-title">Driver Details</h4>
          </div>
        </div>
        <div className="row driver-info-container">
          <div className="col-md-3 col-xl-2  col-sm-6 mb-3">
            <div className="info-item">
              <div className="icon-container">
                <User className="info-icon" />
              </div>
              <div className="info-content">
                <span className="info-label">Driver Name</span>
                <span className="info-value">
                  {data?.first_name || "NA"} {data?.last_name || "NA"}{" "}
                </span>
              </div>
            </div>
          </div>
          <div className="col-md-3 col-xl-2 col-sm-6 mb-3">
            <div className="info-item">
              <div className="icon-container">
                <Mail className="info-icon" />
              </div>
              <div className="info-content">
                <span className="info-label">Driver Email</span>
                <span className="info-value">{data?.email || "NA"}</span>
              </div>
            </div>
          </div>
          <div className="col-md-3 col-xl-2 col-sm-6 mb-3">
            <div className="info-item">
              <div className="icon-container">
                <Phone className="info-icon" />
              </div>
              <div className="info-content">
                <span className="info-label">Phone</span>
                <span className="info-value">{data?.mobile_no || "NA"}</span>
              </div>
            </div>
          </div>
          <div className="col-md-3 col-xl-2 col-sm-6 mb-3">
            <div className="info-item">
              <div className="icon-container">
                <CreditCard className="info-icon" />
              </div>
              <div className="info-content">
                <span className="info-label">Driving License</span>
                <span className="info-value">
                  {data?.driving_licence || "NA"}
                </span>
              </div>
            </div>
          </div>
          <div className="col-xl-4 mb-3">
            <div className="info-item">
              <div className="icon-container">
                <Car className="info-icon" />
              </div>
              <div className="info-content">
                <span className="info-label">Car Info</span>
                <span className="info-value">
                  {carData?.car_tagline || "NA"} /{carData?.car_name || "NA"} /
                  LP#: {carData?.car_no || "NA"}
                  VIN#: {carData?.vin || "NA"} / Make Year:{" "}
                  {carData?.make_year || "NA"} / Model:{" "}
                  {carData?.model_name || "NA"}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="detailcard-container mb-0 newContainerStyle">
        <div className="row">
          <div className="col-md-12">
            <h6
              style={{ fontSize: "18px", borderBottom: "none" }}
              className="driver-details-title m-0 p-0"
            >
              Payment Details
            </h6>
          </div>
        </div>
        <div className="d-flex gap-4">
          <div className="d-flex" style={{ gap: "1px" }}>
            <h4 className="detailcard-title">Pickup Date - </h4>
            <span className="detailcard-total" style={{ fontSize: "16px" }}>
              {" "}
              {Booking.from_date ? mondayDayYearFormat(Booking.from_date) : "DAY"}
            </span>
          </div>
          <div className="d-flex" style={{ gap: "1px" }}>
            <h4 className="detailcard-title">Payment Cycle - </h4>
            <span className="detailcard-total" style={{ fontSize: "16px" }}>
              {" "}
              {Booking.payment_day_week === 2 ? "WEEK" : "DAY"}
            </span>
          </div>
          <div className="d-flex">
            {/* <h4 className="detailcard-title">Rent Generated Upto -</h4> */}
            <h4 className="detailcard-title">Payment Due Date -</h4>
            <span className="detailcard-total" style={{ fontSize: "16px" }}>
              {generatedTill ? formatDateStringdot(generatedTill) : "NA"}
            </span>
          </div>
        </div>
      </div>
      <div className="detailcard-container mt-0 newContainerStyle2">
        <div className="detailcard-item">
          <div className="detailcard-header">
            <h4 className="detailcard-title">Total Amount</h4>
            <span className="detailcard-total">${totalAmount.toFixed(2)}</span>
          </div>
          <div className="detailcard-details">
            <div className="detailcard-info">
              <span className="detailcard-label">Due</span>
              <span className="detailcard-value due">
                ${totalDue.toFixed(2)}
              </span>
            </div>
            <div className="detailcard-info">
              <span className="detailcard-label">Paid</span>
              <span className="detailcard-value paid">
                ${totalPaid.toFixed(2)}
              </span>
            </div>
          </div>

          <div className="detailcard-hover">
            <h5 className="detailcard-hover-title">Details</h5>
            <div className="detailcard-hover-row">
              <span className="detailcard-hover-label">Advance</span>
              <span className="detailcard-hover-value positive">
                ${totalAdvanceBalance.toFixed(2)}
              </span>
            </div>
            <div className="detailcard-hover-row">
              <span className="detailcard-hover-label">Used Discount</span>
              <span className="detailcard-hover-value">
                ${usedDiscount.toFixed(2)}
              </span>
            </div>
            <div className="detailcard-hover-row">
              <span className="detailcard-hover-label">Balance Discount</span>
              <span className="detailcard-hover-value positive">
                ${balanceDiscount.toFixed(2)}
              </span>
            </div>
            <div className="detailcard-hover-row">
              <span className="detailcard-hover-label">Used Adjustment</span>
              <span className="detailcard-hover-value positive">
                ${usedAdjustment.toFixed(2)}
              </span>
            </div>
            <div className="detailcard-hover-row">
              <span className="detailcard-hover-label">Refund</span>
              <span className="detailcard-hover-value negative">
                ${totalRefundAmount.toFixed(2)}
              </span>
            </div>
          </div>
        </div>
        <div className="detailcard-item">
          <div className="detailcard-header">
            <h4 className="detailcard-title">Rent</h4>
            <span className="detailcard-total">${rentTotal.toFixed(2)}</span>
          </div>
          <div className="detailcard-details">
            <div className="detailcard-info">
              <span className="detailcard-label">Due</span>
              <span className="detailcard-value due">
                ${rentDue.toFixed(2)}
              </span>
            </div>
            <div className="detailcard-info">
              <span className="detailcard-label">Paid</span>
              <span className="detailcard-value paid">
                ${rentPaid.toFixed(2)}
              </span>
            </div>
          </div>
          <div className="detailcard-hover">
            <h5 className="detailcard-hover-title">Rent Details</h5>
            <div className="detailcard-hover-row">
              <span className="detailcard-hover-label">Advance</span>
              <span className="detailcard-hover-value">
                ${totalRentBalanceAdvance.toFixed(2)}
              </span>
            </div>
            <div className="detailcard-hover-row">
              <span className="detailcard-hover-label">Used Discount</span>
              <span className="detailcard-hover-value">
                ${rentDiscountUsed.toFixed(2)}
              </span>
            </div>
            <div className="detailcard-hover-row">
              <span className="detailcard-hover-label">Balance Discount</span>
              <span className="detailcard-hover-value positive">
                ${rentDiscountBalance.toFixed(2)}
              </span>
            </div>
            <div className="detailcard-hover-row">
              <span className="detailcard-hover-label">Used Adjustment</span>
              <span className="detailcard-hover-value positive">
                ${usedAdjustment.toFixed(2)}
              </span>
            </div>
          </div>
        </div>

        <div className="detailcard-item">
          <div className="detailcard-header">
            <h4 className="detailcard-title">Tolls</h4>
            <span className="detailcard-total">${tollsTotal.toFixed(2)}</span>
          </div>
          <div className="detailcard-details">
            <div className="detailcard-info">
              <span className="detailcard-label">Due</span>
              <span className="detailcard-value due">
                ${tollsDue.toFixed(2)}
              </span>
            </div>
            <div className="detailcard-info">
              <span className="detailcard-label">Paid</span>
              <span className="detailcard-value paid">
                ${tollsPaid.toFixed(2)}
              </span>
            </div>
          </div>
          <div className="detailcard-hover">
            <h5 className="detailcard-hover-title">Tolls Details</h5>
            <div className="detailcard-hover-row">
              <span className="detailcard-hover-label">Advance</span>
              <span className="detailcard-hover-value">
                ${totalTollBalanceAdvance.toFixed(2)}
              </span>
            </div>
            <div className="detailcard-hover-row">
              <span className="detailcard-hover-label">Used Discount</span>
              <span className="detailcard-hover-value">
                ${tollsDiscountUsed.toFixed(2)}
              </span>
            </div>
            <div className="detailcard-hover-row">
              <span className="detailcard-hover-label">Balance Discount</span>
              <span className="detailcard-hover-value">
                ${tollsDiscountBalance.toFixed(2)}
              </span>
            </div>
          </div>
        </div>

        <div className="detailcard-item">
          <div className="detailcard-header">
            <h4 className="detailcard-title">Damage</h4>
            <span className="detailcard-total">${damageTotal.toFixed(2)}</span>
          </div>
          <div className="detailcard-details">
            <div className="detailcard-info">
              <span className="detailcard-label">Due</span>
              <span className="detailcard-value due">
                ${damageDue.toFixed(2)}
              </span>
            </div>
            <div className="detailcard-info">
              <span className="detailcard-label">Paid</span>
              <span className="detailcard-value paid">
                ${damagePaid.toFixed(2)}
              </span>
            </div>
          </div>
          <div className="detailcard-hover">
            <h5 className="detailcard-hover-title">Damage Details</h5>
            <div className="detailcard-hover-row">
              <span className="detailcard-hover-label">Used Discount</span>
              <span className="detailcard-hover-value">
                ${damageDiscountUsed.toFixed(2)}
              </span>
            </div>
            <div className="detailcard-hover-row">
              <span className="detailcard-hover-label">Balance Discount</span>
              <span className="detailcard-hover-value">
                ${damageDiscountBalance.toFixed(2)}
              </span>
            </div>
          </div>
        </div>

        <div className="detailcard-item">
          <div className="detailcard-header">
            <h4 className="detailcard-title">Tickets</h4>
            <span className="detailcard-total">${ticketsTotal.toFixed(2)}</span>
          </div>
          <div className="detailcard-details">
            <div className="detailcard-info">
              <span className="detailcard-label">Due</span>
              <span className="detailcard-value due">
                ${ticketsDue.toFixed(2)}
              </span>
            </div>
            <div className="detailcard-info">
              <span className="detailcard-label">Paid</span>
              <span className="detailcard-value paid">
                ${ticketsPaid.toFixed(2)}
              </span>
            </div>
          </div>
          <div className="detailcard-hover">
            <h5 className="detailcard-hover-title">Tickets Details</h5>
            <div className="detailcard-hover-row">
              <span className="detailcard-hover-label">Used Discount</span>
              <span className="detailcard-hover-value">
                ${ticketsDiscountUsed.toFixed(2)}
              </span>
            </div>
            <div className="detailcard-hover-row">
              <span className="detailcard-hover-label">Balance Discount</span>
              <span className="detailcard-hover-value">
                ${damageDiscountBalance.toFixed(2)}
              </span>
            </div>
          </div>
        </div>

        <div className="detailcard-item">
          <div className="detailcard-header">
            <h4 className="detailcard-title">Other Charges</h4>
            <span className="detailcard-total">
              ${otherChargesTotal.toFixed(2)}
            </span>
          </div>
          <div className="detailcard-details">
            <div className="detailcard-info">
              <span className="detailcard-label">Due</span>
              <span className="detailcard-value due">
                ${otherChargesDue.toFixed(2)}
              </span>
            </div>
            <div className="detailcard-info">
              <span className="detailcard-label">Paid</span>
              <span className="detailcard-value paid">
                ${otherChargesPaid.toFixed(2)}
              </span>
            </div>
          </div>
          <div className="detailcard-hover">
            <h5 className="detailcard-hover-title">Tickets Details</h5>
            <div className="detailcard-hover-row">
              <span className="detailcard-hover-label">Used Discount</span>
              <span className="detailcard-hover-value">
                ${otherChargesDiscountUsed.toFixed(2)}
              </span>
            </div>
            <div className="detailcard-hover-row">
              <span className="detailcard-hover-label">Balance Discount</span>
              <span className="detailcard-hover-value">
                ${otherChargesDiscountBalance.toFixed(2)}
              </span>
            </div>
          </div>
        </div>

        {/* <div className="detailcard-item">
          <div className="detailcard-header">
            <h4 className="detailcard-title">Late Fees</h4>
            <span className="detailcard-total">${lateFeesTotal}</span>
          </div>
          <div className="detailcard-details">
            <div className="detailcard-info">
              <span className="detailcard-label">Due</span>
              <span className="detailcard-value due">
                ${lateFeesDue.toFixed(2)}
              </span>
            </div>
            <div className="detailcard-info">
              <span className="detailcard-label">Paid</span>
              <span className="detailcard-value paid">
                ${lateFeesPaid.toFixed(2)}
              </span>
            </div>
          </div>
          <div className="detailcard-hover">
            <h5 className="detailcard-hover-title">Late Fees Details</h5>
            <div className="detailcard-hover-row">
              <span className="detailcard-hover-label">Total Discount</span>
              <span className="detailcard-hover-value">
                ${lateFeesDiscount.toFixed(2)}
              </span>
            </div>
            <div className="detailcard-hover-row">
              <span className="detailcard-hover-label">Balance Discount</span>
              <span className="detailcard-hover-value">
                ${lateFeesDiscountBalance.toFixed(2)}
              </span>
            </div>
          </div>
        </div> */}

        <div className="detailcard-item">
          <div className="detailcard-header">
            <h4 className="detailcard-title">
              {Booking.step_for_booking > 4 ? "Past Deposit" : "Deposit"}
            </h4>
            <span className="detailcard-total">${depositTotal.toFixed(2)}</span>
          </div>
          <div className="detailcard-details">
            <div className="detailcard-info">
              <span className="detailcard-label">Due</span>
              <span className="detailcard-value due">
                ${depositDue.toFixed(2)}
              </span>
            </div>
            <div className="detailcard-info">
              <span className="detailcard-label">Paid</span>
              <span className="detailcard-value paid">
                ${depositPaid.toFixed(2)}
              </span>
            </div>
          </div>
        </div>
      </div>

      <ViewDiscountModal
        show={showDiscountModal}
        onHide={() => setShowDiscountModal(false)}
        discounts={discounts}
      />
    </div>
  );
}
